module.exports = __webpack_public_path__ + "static/media/logo_daofa.4e0c21dc.png";